import React, { Component } from 'react';
import {
    Row, Col, Container
} from 'reactstrap'
import './Layout.css'
// import String from '../../../assets/Locales/teacher_locales'
import { initNotif } from '../../../redux/Action/ChatAction'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom';
import { LoginRequest, IntializeToken, UpdateUser, activateStudent } from '../../../redux/Action/Auth/LoginAction'
import SideMenu from '../SideMenu/SideMenu'
import routes from '../../../routes/routes'
import Header from '../Header/header'
import AppointementsSideMenu from '../AppointementsSideMenu/AppointementsSideMenu'
import LoadingBar from 'react-redux-loading-bar';
import { GetAssignRequest } from '../../../redux/Action/AssignRules'
class Layout extends Component {

    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.state = {
            activeTab: '0',
            getDay: '',
            date: '',
            search: null,
            redirect: false
        };
    }
    componentWillMount() {
        if (localStorage.getItem("id") || localStorage.getItem("id") !== "") this.props.initNotif()
        let d = new Date();
        let n = d.getDay();
        this.setState({ getDay: n, activeTab: 0 })
        // console.log("ACTIVVVE", this.props.activStudent)
        if (this.props.token) {
            this.props.GetAssignRequest(this.props.token, this.props.user.id)
            // this.props.activateStudent(this.props.activStudent)
        }
        else {
            let token = localStorage.getItem('Korasatoken')
            let user = ''
            if (localStorage.getItem("KorasaAppuser") || localStorage.getItem("KorasaAppuser") !== "") user = JSON.parse(localStorage.getItem('KorasaAppuser'))
            let type = localStorage.getItem('KorasauserType')
            let lang = localStorage.getItem('Language')
            if (token) {
                this.props.IntializeToken(token, type, user, lang)
                // this.props.activStudent.length > 0 && this.props.activateStudent(this.props.activStudent)
                this.props.GetAssignRequest(JSON.parse(token), user.id)
            }


        }
        this.setState({ redirect: false })

    }
    toggle(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }
    fetchClander(Date) {

    }
    getsearchData = (search, redirect) => {
        this.setState({ search: search, redirect: redirect })
    }
    render() {

        let token = localStorage.getItem('Korasatoken')
        let userType = localStorage.getItem("KorasauserType") ? JSON.parse(localStorage.getItem("KorasauserType")) : ' '
        if (this.state.redirect) {
            return (<Redirect to={{
                pathname: '/Search',
                state: {
                    search: this.state.search,
                }
            }} />)
        }
        return (
            token || userType === "VISITOR" ?
                <div className="AllView" id={this.props.userType === 'TEACHER' ? "teacher" : this.props.userType === 'ASSISTANT' ? "assistant" :
                    this.props.userType === 'STUDENT' ? "student" : this.props.userType === 'GUARDIAN' ? "parent" : "visitor"} style={{ backgroundColor: '#EFEFEF', minHeight: '980px' }}>
                    <div className="loading-bar" >
                        <LoadingBar style={{
                            height: '5px', zIndex: 1250,
                            backgroundColor: this.props.userType === 'GUARDIAN' ? "#37BBAE" : this.props.userType === 'ASSISTANT' ? '#020D43' : this.props.userType === 'TEACHER' ? "#e29626" : '#83C583',
                            top: '0'
                        }} />
                    </div>
                    <Container fluid className="pl-0" style={{ direction: this.props.lang === "ar" ? "ltr" : "rtl" }}>
                        <Header />
                        <Row className="p-0 mainrow" >
                            <Col lg="3" sm="4" className="m-0 p-0 appointmentrow">
                                <AppointementsSideMenu />
                            </Col>

                            <Col lg="6" sm="8" id="smallscreen" className={this.props.lang === "ar" ? "text-right" : "text-left"}>
                                <div className="ViewContent">
                                    <Switch>
                                        {routes.map((route, idx) => {
                                            return route.component ? (<Route key={idx} path={route.path} exact={route.exact} name={route.name} render={props => (
                                                <route.component {...props} />
                                            )} />)
                                                : (null);
                                        },
                                        )}
                                        <Redirect from="/" to="/home" />
                                    </Switch>
                                </div>
                            </Col>

                            <Col lg="3" className="smallhide p-0">
                                <SideMenu />
                            </Col>

                        </Row>
                    </Container>
                </div> : <Redirect to="/login" />
        );
    }
}


const mapStateToProps = state => {

    return {
        userType: state.login.userType,
        lang: state.lang.lang,
        token: state.login.token,
        user: state.login.user,
        activStudent: state.login.activeStudent
    }
}
const mapDispatchToProps = dispatch => bindActionCreators(
    {
        LoginRequest,
        IntializeToken, activateStudent,
        initNotif, UpdateUser, GetAssignRequest
    }
    , dispatch
)
export default (connect(mapStateToProps, mapDispatchToProps)(Layout));